import React, { Component } from 'react';
import '../Styles/css/Contact.css';
import { instagramIcon, facebookIcon, twitterIcon } from '../assets';

export default class Contact extends Component {

    render() {

        return (
            <div className="Contact">
                <h1>CONTACT</h1>

                <div className="contact-info">
                    <div className="booking">
                        <h2 className="title">Booking</h2>
                        <div className="emails">
                            <a href="https://www.highroadtouring.com/" target="_blank" rel="noopener noreferrer"><span>High Road Touring</span></a>
                            <a className="list-item" href="mailto:zachary@highroadtouring.com"><p>zachary@highroadtouring.com</p></a>
                            <a href="mailto:sam@highroadtouring.com"><p>sam@highroadtouring.com</p></a>
                        </div>
                    </div>
                    <div className="general">
                        <h2 className="title">General</h2>
                        <div className="emails">
                            <a href="mailto:flauralmusic@gmail.com"><p className="flauralEmail">flauralmusic@gmail.com</p></a>
                        </div>
                    </div>
                </div>
                <div className="social">
                    <a href="https://www.instagram.com/flauralmusic/" target="_blank" rel="noopener noreferrer" alt="instagram" title="Instagram"><img src={ instagramIcon } alt="Instagram" /></a>
                    <a href="https://www.facebook.com/flauralmusic/" target="_blank" rel="noopener noreferrer" alt="facebook" title="Facebook"><img src={ facebookIcon } alt="Facebook" /></a>
                    <a href="https://twitter.com/flauralmusic?lang=en" target="_blank" rel="noopener noreferrer" alt="twitter" title="Twitter"><img src={ twitterIcon } alt="Twitter" /></a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Containers/Contact.js